import React from 'react';
import { connect } from 'react-redux';
import { get, isEmpty } from 'lodash';

import pagesRoutes from '../../../routes/pages';
import asyncRoute from '../../../helpers/hoc/asyncRoute';
import { handleMailLink, isInstagramBrowser, safeDecode } from '../../../utils/helpers';
import { handleLinkUrl, handlePhoneNumber } from '../../Rewards/helpers';

import './PrivacyPolicy.scss';

const Icons = asyncRoute(() => import('../../../components/Icons'));

const PrivacyPolicy = ({ location, history, staticPages }) => {
  const urlParams = new URLSearchParams(window.location.search);
  const rawTarget = urlParams.get('target');
  const target = rawTarget ? safeDecode(rawTarget) : '';

  const privacyPolicyContent =
    staticPages &&
    staticPages.length > 0 &&
    staticPages.find((sPage) => sPage.route === pagesRoutes.containers.privacyPolicy);
  const privacyPolicyTemplate = get(privacyPolicyContent, 'content', '');

  const onClickHandler = (event) => {
    if (event) {
      const dataType = event.target.dataset && event.target.dataset.type;
      const dataLink = event.target.dataset && event.target.dataset.link;
      switch (dataType) {
        case 'mail':
          return handleMailLink({
            mailLink: dataLink,
          });
        case 'link':
          return handleLinkUrl({
            linkUrl: dataLink,
            context: 'default-browser',
          });
        case 'phone':
          return handlePhoneNumber({ phoneNumber: dataLink });
        default:
          return;
      }
    }
  };

  const handleGoBack = () => {
    if (!isEmpty(target)) {
      window.location.replace(target);
    } else {
      history.goBack();
    }
  };

  return (
    <>
      <div className="app-privacy-policy">
        {isInstagramBrowser() && (
          <div className="app-privacy-policy_back">
            <Icons type={'back'} onClick={handleGoBack} />
          </div>
        )}
        <div
          className="app-privacy-policy_content"
          onClick={(event) => onClickHandler(event)}
          dangerouslySetInnerHTML={{ __html: privacyPolicyTemplate }}
        />
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  staticPages: get(state, 'common.resources.staticPages', []),
});

export default connect(mapStateToProps, null)(PrivacyPolicy);
